import { Component } from "react";
import { clearChunkReloadFlag } from "../../utils/loadWithChunkRetry";

function formatErrorMessage(error) {
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return "Something went wrong while loading iTEMA.";
}

export class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.handleRetry = this.handleRetry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    const isDev =
      typeof process !== "undefined" &&
      process.env &&
      process.env.NODE_ENV !== "production";
    if (isDev) {
      console.error("[iTEMA] Render error", error, info?.componentStack);
    }
  }

  handleRetry() {
    clearChunkReloadFlag();
    this.setState({ error: null });
    window.location.reload();
  }

  render() {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }

    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f8fafc] px-4">
        <div
          className="w-full max-w-lg rounded-xl border border-[#e5e7eb] bg-white p-8 shadow-sm"
          role="alert"
        >
          <p className="text-xs font-semibold tracking-wide text-[#f19500]">
            iTEMA
          </p>
          <h1 className="mt-2 text-xl font-bold text-[#111827]">
            We could not load this page
          </h1>
          <p className="mt-2 text-sm text-[#494551]">{formatErrorMessage(error)}</p>
          <div className="mt-6 flex flex-wrap gap-3">
            <button
              type="button"
              className="rounded-lg bg-[#f19500] px-4 py-2 text-sm font-semibold text-white hover:bg-[#875300]"
              onClick={this.handleRetry}
            >
              Reload app
            </button>
            <button
              type="button"
              className="rounded-lg border border-[#e5e7eb] px-4 py-2 text-sm font-semibold text-[#494551] hover:bg-[#f8fafc]"
              onClick={() => {
                clearChunkReloadFlag();
                sessionStorage.clear();
                window.location.href = `${window.location.origin}${window.location.pathname}`;
              }}
            >
              Clear session &amp; sign in again
            </button>
          </div>
        </div>
      </div>
    );
  }
}
